import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import routes from 'config/routes'
import PropTypes from 'prop-types'
import React from 'react'
import { Button, Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import SessionList from './SessionList'

function RecentSessions(props) {
  return (
    <Card className="stat-card shadow">
      <Card.Body>
        <div className="mb-3 clearfix">
          {props.sessions.length > 0 ? (
            <Button
              variant="warning"
              size="sm"
              as={Link}
              to={routes.sessionNew}
              className="float-right"
            >
              <FontAwesomeIcon icon={['far', 'plus']} fixedWidth />
              ADD SESSION
            </Button>
          ) : null}
          <Card.Title>RECENT SESSIONS</Card.Title>
        </div>
        {props.sessions.length > 0 ? (
          <>
            <SessionList
              sessions={props.sessions}
              actions={false}
              comments={false}
            />
            <div className="text-right mt-3">
              <Link to={routes.sessions} className="btn btn-warning btn-sm">
                MORE
                <FontAwesomeIcon icon={['far', 'angle-right']} fixedWidth />
              </Link>
            </div>
          </>
        ) : (
          <div className="my-5 text-center">
            <Button variant="warning" as={Link} to={routes.sessionNew}>
              <FontAwesomeIcon icon={['far', 'plus']} fixedWidth />
              ADD SESSION
            </Button>
          </div>
        )}
      </Card.Body>
    </Card>
  )
}

RecentSessions.propTypes = {
  sessions: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default RecentSessions
